module.exports = __webpack_public_path__ + "img/3.06f9574c.png";